import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { Modal } from 'components';
import ICONS from 'components/Icons';
import { Text } from 'components/chroma';

export const MODAL_HEADER = 'Finding your Flybuys number';

const SmallFlybuysCard = styled.img`
  width: 20rem;
  height: 10rem;
`;

const FlybuysLocationModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal header={MODAL_HEADER} isOpen={isOpen} onClose={onClose}>
    <Text>
      Your Flybuys number can be found on the back of your card. It is listed
      under your name.
    </Text>
    <SmallFlybuysCard
      src={ICONS.CARD.FLYBUYS}
      tabIndex={-1}
      alt="Flybuys card graphic"
    />
  </Modal>
);

export default FlybuysLocationModal;
